import { createSelector } from '@ngrx/store';

import { selectPageState } from '../../_state';

export const selectLayoutType = createSelector(selectPageState, state => state.layoutType);
